import { render, staticRenderFns } from "./TabList.vue?vue&type=template&id=17e3daac&scoped=true"
import script from "./TabList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TabList.vue?vue&type=style&index=0&id=17e3daac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e3daac",
  null
  
)

export default component.exports